var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":function (e) { return e.stopPropagation(); }}},[_c('v-menu',{attrs:{"bottom":"","left":"","offset-y":""}},[_c('div',{class:{ 'circle-status': true, border: !_vm.backgroundColor },style:({
        backgroundColor: _vm.backgroundColor,
      }),attrs:{"slot":"activator"},slot:"activator"}),_c('div',{staticClass:"dt-list-v2",staticStyle:{"background-color":"white"}},_vm._l((_vm.statusTVList),function(statusItem,index){return _c('div',{key:index,staticClass:"ut-flex dt-list--item",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.onChange({
            itemID: _vm.item.itemID,
            colorPropertyName: _vm.item.colorPropertyName,
            colorPropertyValue: statusItem.id,
            colorValue: statusItem.value,
            colorName: _vm.item.colorName,
          })}}},[_c('div',{staticClass:"circle-status",style:({
            backgroundColor: ("#" + (statusItem.value)),
            height: '16px',
            width: '16px',
            minWidth: '16px',
          })}),_vm._v("\n        "+_vm._s(statusItem.text)+"\n      ")])}),0)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }